import React from 'react';
import ReactDOM from 'react-dom';
import './styles/styles.scss';
import App from './containers/App/App';
import { BrowserRouter } from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import configureStore from './store/store';

const { persistor, store } = configureStore();

/**
 * @ignore
 *
 * The entry point for the app.
 * Here we hook our React app into the DOM. We also import and wrap our app (`App.js` component) with various providers -- see code comments below.
 */
ReactDOM.render(
    // Helps us detect potential coding issues; see <https://reactjs.org/docs/strict-mode.html>:
    <React.StrictMode>
        {/* gives us the rest of the app access to the store: */}
        <Provider store={store}>
            {/* allows the state to be persisted (e.g. when we refresh the browser): */}
            <PersistGate loading={null} persistor={persistor}>
                {/* enables client-side routing for our app  */}
                <BrowserRouter>
                    {/* the root component of our app: */}
                    <App/>
                </BrowserRouter>
            </PersistGate>
        </Provider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
